<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
//import HelloWorld from './components/HelloWorld.vue'

import 'materialize-css'
import 'materialize-css/dist/css/materialize.css'
import './assets/css/styles.css'
import 'material-design-icons/iconfont/material-icons.css'

export default {
  name: 'App'
}
</script>
